<template>
  <v-card width="100%" class="mx-auto">
    <v-card-title>{{ title || "Choose Teacher" }}</v-card-title>
    <v-card-text class="mt-5">
      <auto-suggest
        v-model="teacher"
        :showAddButton="false"
        label="Search teacher with email or name"
        suggestionValue="id"
        suggestionText="label"
        @selected="selectedTeacher"
        @search="searchTeachers"
      />
      <!-- <v-select
        v-model="teacher"
        :items="teachers"
        item-value="id"
        item-text="name"
        label="Teacher"
      /> -->
    </v-card-text>
    <!-- <v-card-actions>
      <v-spacer />
      <v-btn @click="selectedTeacher">Select Teacher</v-btn>
      <v-spacer />
    </v-card-actions> -->
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AutoSuggest from "@/components/common/AutoSuggest.vue";
export default {
  components: { AutoSuggest },
  props: ["value", "title"],
  data() {
    return {
      teachers: [],
      teacher: null,
      registered: true
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"])
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    async searchTeachers(term, callback) {
      const data = {
        searchTerm: term,
        pageSize: 100,
        sortInfos: [{ sortCol: "first_name", sortDir: "asc" }],//must use first_name because searchTerm uses native query
        registered: this.registered
      };

      return await this.$axios
        .post("/teacher/search", data)
        .then(resp => {
          let matchingTeachers = resp.data.data.content.map(t => {
            return { id: t.id, label: `${t.firstName} ${t.lastName}` };
          });

          if (matchingTeachers && matchingTeachers.length < 1) {
            matchingTeachers = [{ id: 0, label: "No match found" }];
          }

          callback(matchingTeachers);
          console.log(matchingTeachers);
          return matchingTeachers;
        })
        .catch(() => {
          const empty = [{ id: 0, label: "No match found" }];
          callback(empty);
          return empty;
        });
    },
    selectedTeacher() {
      if (this.teacher && this.teacher.id) {
        this.$emit("input", this.teacher);
        this.$emit("selected", this.teacher);
      } else {
        this.addErrorMessage("Please choose a teacher");
      }
    }
  }
};
</script>

<style></style>
